var map = {
	"./views-v3/GameType": [
		"bed2",
		"chunk-0ebfe8bd",
		"chunk-5e5c74f0",
		"chunk-2c109ff4",
		"chunk-096da05b",
		"chunk-64760b43"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0585";
module.exports = webpackAsyncContext;